var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @file 标签页
 */
import { isArray, isString } from '@seiue/util';
import Radio from 'antd/es/radio';
import TabsAntd from 'antd/es/tabs';
import classNames from 'classnames';
import styled, { css } from 'styled-components';
import { CustomTabBar } from './CustomTabBar';
const TabsComponent = (_a) => {
    var { type = 'line', tabBarStyle, hideTabBarBottomBorder } = _a, tabsProps = __rest(_a, ["type", "tabBarStyle", "hideTabBarBottomBorder"]);
    const tabsClassName = classNames({
        'se-tabs_hide-bottom-border': hideTabBarBottomBorder,
    }, tabsProps.className);
    switch (type) {
        case 'card':
            return (_jsx(TabsCard, Object.assign({ "data-test-id": "\u9875\u7B7E\u680F" }, { children: _jsx(TabsStyled, Object.assign({}, tabsProps, { className: tabsClassName, tabBarStyle: tabBarStyle, type: "line" }), void 0) }), void 0));
        case 'solid-button':
        case 'outline-button':
            return (_jsx(TabsStyled, Object.assign({}, tabsProps, { className: tabsClassName, "data-test-id": "\u9875\u7B7E\u680F", type: "line", renderTabBar: props => {
                    const isSolidButton = type === 'solid-button';
                    const buttonGroupProps = {
                        size: 'small',
                        value: props.activeKey,
                        defaultValue: props.activeKey,
                        buttonStyle: isSolidButton ? 'solid' : 'outline',
                        onChange: e => { var _a; return (_a = props.onTabClick) === null || _a === void 0 ? void 0 : _a.call(props, e.target.value, e); },
                    };
                    const children = isArray(props.panes)
                        ? props.panes.map((pane, index) => (_jsx(Radio.Button, Object.assign({ className: pane.key ? `se-tabs_${pane.props.tab}` : '', value: pane.key }, { children: pane.props.tab }), pane.key || index)))
                        : null;
                    const noMargin = !!tabsProps.tabBarExtraContent;
                    return (_jsx(CustomTabBar, Object.assign({ tabBarExtraContent: tabsProps.tabBarExtraContent, style: noMargin ? { marginBottom: 16 } : undefined }, { children: isSolidButton ? (_jsx(SolidButtonGroup, Object.assign({ style: tabBarStyle, "$noMargin": noMargin }, buttonGroupProps, { children: children }), void 0)) : (_jsx(OutlineButtonGroup, Object.assign({ style: tabBarStyle, "$noMargin": noMargin }, buttonGroupProps, { children: children }), void 0)) }), void 0));
                } }), void 0));
        case 'link':
            return (_jsx(TabsStyled, Object.assign({}, tabsProps, { className: tabsClassName, "data-test-id": "\u9875\u7B7E\u680F", type: "line", renderTabBar: props => {
                    const buttonGroupProps = {
                        size: 'small',
                        value: props.activeKey,
                        defaultValue: props.activeKey,
                        onChange: e => { var _a; return (_a = props.onTabClick) === null || _a === void 0 ? void 0 : _a.call(props, e.target.value, e); },
                    };
                    return (_jsx(CustomTabBar, Object.assign({ tabBarExtraContent: tabsProps.tabBarExtraContent }, { children: _jsx(LinkButtonGroup, Object.assign({ style: tabBarStyle }, buttonGroupProps, { children: isArray(props.panes)
                                ? props.panes.map((pane, index) => (_jsx(Radio.Button, Object.assign({ className: pane.key ? `se-tabs_${pane.props.tab}` : '', value: pane.key, type: "link" }, { children: pane.props.tab }), pane.key || index)))
                                : null }), void 0) }), void 0));
                } }), void 0));
        case 'editable-card':
            return (_jsx(TabsStyled, Object.assign({}, tabsProps, { className: tabsClassName, "data-test-id": "\u9875\u7B7E\u680F", tabBarStyle: tabBarStyle, type: "editable-card" }), void 0));
        case 'unified':
            return (_jsx(TabsStyled, Object.assign({}, tabsProps, { className: tabsClassName, "data-test-id": "\u9875\u7B7E\u680F", tabBarStyle: tabBarStyle, type: "card" }), void 0));
        case 'line':
        default:
            return (_jsx(TabsStyled, Object.assign({}, tabsProps, { className: tabsClassName, "data-test-id": "\u9875\u7B7E\u680F", tabBarStyle: tabBarStyle, type: "line" }), void 0));
    }
};
export const TabPane = props => (_jsx(TabsAntd.TabPane, Object.assign({ "data-test-id": isString(props.tab) ? `${props.tab}页签` : '页签内容区' }, props), void 0));
/**
 * 右上角有数字的 tab 头，超过 99 显示为 99+
 */
export const TabWithCount = ({ name, count, active }) => (_jsxs(TabNameWrapper, Object.assign({ active: active }, { children: [name, count != null ? (_jsx(TabNameCount, { children: count > 99 ? '99+' : count }, void 0)) : null] }), void 0));
export const Tabs = TabsComponent;
Tabs.TabPane = TabPane;
Tabs.TabWithCount = TabWithCount;
const TabsStyled = styled(TabsAntd) `
  /* 解决 Safari Tab 高度塌陷的问题 */
  flex-shrink: 0;

  && {
    .ant-tabs-nav::before {
      border-bottom: 1px solid rgba(50, 56, 66, 0.1);
    }

    .ant-tabs-nav {
      height: 44px;
    }

    &.ant-tabs-card {
      .ant-tabs-nav {
        height: auto;
        margin-bottom: 0;
        .ant-tabs-tab {
          padding: 8px 12px;
        }
      }

      .ant-tabs-tabpane {
        border: 1px solid rgba(0, 0, 0, 0.06);
        border-top: none;
        border-radius: 0 0 4px 4px;
      }
    }

    &.ant-tabs-editable-card {
      .ant-tabs-nav {
        .ant-tabs-tab {
          padding: 8px 8px 8px 12px;
        }
      }
    }

    .ant-tabs-tab {
      justify-content: center;
      min-width: 72px;
      padding: 8px;
      color: rgba(6, 12, 25, 0.45);
      font-weight: bold;
      font-size: 14px;
      white-space: normal;
    }

    .ant-tabs-tab + .ant-tabs-tab {
      margin: 0 0 0 16px;
    }

    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      font-weight: bold;
      text-shadow: none;
    }

    .ant-tabs-ink-bar {
      border-radius: 1px;
    }
  }
`;
const TabsCard = styled.div `
  padding: 8px 24px 24px 24px;
  background-color: #ffffff;
  border-radius: 6px;
`;
const ButtonGroup = styled(Radio.Group) `
  &&& {
    margin-bottom: 16px;

    .ant-radio-button-wrapper {
      min-width: 72px;
      font-weight: normal;
      text-align: center;

      &:focus-within {
        box-shadow: none;
      }
    }
  }
`;
const SolidButtonGroup = styled(ButtonGroup) `
  &&& {
    ${p => p.$noMargin &&
    css `
        margin: 0;
      `};

    .ant-radio-button-wrapper {
      color: rgba(6, 12, 25, 0.45);
      font-weight: bold;
      border-color: transparent;

      &:hover {
        color: rgba(6, 12, 25, 0.45);
        background-color: rgb(231, 232, 237);
      }

      &::before {
        width: 0;
      }

      &:first-child {
        border-right-color: transparent;
      }
    }

    .ant-radio-button-wrapper-checked {
      color: ${p => p.theme.brand._1};
      background-color: #fff;

      &:hover {
        color: rgba(6, 12, 25, 0.45);
        background-color: rgb(231, 232, 237);
        border-color: rgb(231, 232, 237);
      }
    }
  }
`;
const OutlineButtonGroup = styled(ButtonGroup) `
  &&& {
    ${p => p.$noMargin &&
    css `
        margin: 0;
      `};

    .ant-radio-button-wrapper {
      min-width: 72px;
      text-align: center;
    }
  }
`;
const LinkButtonGroup = styled(ButtonGroup) `
  &&& {
    margin-bottom: 0;

    .ant-radio-button-wrapper {
      min-width: 72px;
      color: rgba(6, 12, 25, 0.45);
      text-align: center;
      background-color: transparent;
      border: none;
      ::before {
        display: none;
      }
    }
    .ant-radio-button-wrapper-checked {
      color: rgba(6, 12, 25, 0.85);
      font-weight: bold;
    }

    .ant-tabs-content-holder {
      display: none;
    }
    .ant-radio-group {
      margin-bottom: 0;
    }
  }
`;
const TabNameWrapper = styled.div `
  position: relative;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
  color: ${props => props.active ? 'rgba(6, 12, 25, 0.85)' : 'rgba(6, 12, 25, 0.45)'};
`;
const TabNameCount = styled.div `
  position: absolute;
  top: -5px;
  right: -30px;
  width: 24px;
  font-size: 12px;
`;
//# sourceMappingURL=data:application/json;base64,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